import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { Button, Menu, MenuItem, Typography } from "@mui/material";
import { useRef, useState } from "react";
import type { TAdditionalFilterOption } from "./logics";

export interface IAdditionalFiltersMenuProps {
  options: TAdditionalFilterOption[];
  onSelectOption: (option: TAdditionalFilterOption) => void;
}

export const AdditionalFiltersMenu = ({ options, onSelectOption }: IAdditionalFiltersMenuProps) => {
  const [open, setOpen] = useState(false);
  const anchorEl = useRef<HTMLButtonElement>(null);

  return (
    <>
      <Button
        sx={{ alignSelf: "start", borderWidth: 1, "&:hover": { borderWidth: 1 } }}
        variant="outlined"
        color="primary"
        onClick={() => setOpen(true)}
        size="small"
        startIcon={<AddIcon />}
        endIcon={open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
        ref={anchorEl}
      >
        <Typography
          variant="body1SemiBold"
          sx={{
            textTransform: "none",
          }}
        >
          Ajouter un filtre
        </Typography>
      </Button>
      <Menu
        open={open}
        anchorEl={anchorEl.current}
        onClose={() => setOpen(false)}
        slotProps={{
          paper: {
            variant: "outlined",
            elevation: 0,
            sx: (theme) => ({
              borderColor: theme.palette.border.main,
              minWidth: anchorEl.current?.offsetWidth,
              maxHeight: 200,
              filter: "unset",
            }),
          },
        }}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            onClick={() => {
              onSelectOption(option);
              setOpen(false);
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
